export default {
    app: {
        name: '汉中南湖综合管理平台',
        name_en: 'Integrated Management Platform Of HanZhong NanHu',
        logo: '/img/logo.png',
        menu_code: 'sys-scenic-imclient',
        theme: '/theme/default',
        base_url: '/',
        homePage: '/'
    },

    copyright: {
        visiable: true,
        text: 'Copyright © 2020 北京中景合天科技有限公司 All Rights Resolved'
    },

    // WebApi
    api: {
        base_url: 'http://192.168.1.210:9000',
        // base_url: 'http://192.168.56.132:9000',
        // base_url: 'http://114.116.212.138:8090',
        version: '1.0',
    },

    // 消息通知
    notify: {
        url: 'ws://192.168.56.132:8181/notify',
        //url: 'ws://127.0.0.1:8181/notify',
        proxy: 'ws://127.0.0.1:8989/proxy'
    },
    
    // 媒体中心
    mediaCenter: {
        address: '192.168.58.213:8282',
        mode: 'tcp' // tcp|upd - 连接媒体中心的方式
    },

    // 验证码
    captcha: {
        enabled: true,
        // base_url 必须以 _t= 结尾，会自动补上时间戳
        base_url: 'http://222.87.6.234:8092/Account/ValidateImg?_t=',
        length: 4,
    },

    // 登录会话
    session: {
        // 1 小时候后 Session 过期
        timeout: 1 * 60 * 60 * 1000,
    },

    // UI 界面
    ui: {
        loginComponent: 'ZjEmergencyLogin'
    }
};